export function pushNotifications(btn) {
   //const applicationServerKey =
    // 'BMBlr6YznhYMX3NgcWIDRxZXs0sh7tCv7_YCsWcww0ZCv9WGg-tRCXfMEHTiBPCksSqeve1twlbmVAZFv7GSuj0';
  let isPushEnabled = false;
  let isButtonDisabled = false
  const btnState = {
    isDisabled: false,
    isEnabled: false,
    icon: 'fa-bell',
    title: ''
  }
  const pushButton = btn

  const getWebPushKey = () => {
    const cookie = document.cookie
    if (!cookie) return ''
    const arr = cookie.split(' ')
    let item = arr.find(e => e.includes('web_push_key'))
    if (!item) return ''
    item = item.split('=')[1]
    return item[item.length - 1] === ';' ? item.slice(0, -1) : item
  }
  const applicationServerKey = getWebPushKey()
  const isPossibleUseNotification = () => {
    if (!('serviceWorker' in navigator)) {
      console.warn('Service workers are not supported by this browser');
      changePushButtonState('incompatible');
      return false
    }
    if (!('PushManager' in window)) {
      console.warn('Push notifications are not supported by this browser');
      changePushButtonState('incompatible');
      return false
    }
    if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
      console.warn('Notifications are not supported by this browser');
      changePushButtonState('incompatible');
      return false
    }
    if (Notification.permission === 'denied') {
      console.warn('Notifications are denied by the user');
      changePushButtonState('incompatible');
      return false
    }
    return true
  }
  const changeBtnUi = () => {
    const iconWrap = pushButton.querySelector('.fa')
    const iconText = pushButton.querySelector('[data-text]')

    const isSubscribe = JSON.parse(localStorage.getItem('isSubscribe'))
    if (!isSubscribe) {
      iconWrap.classList.add('fa-bell')
      iconWrap.classList.remove('fa-bell-slash')
      iconText.textContent = ' Активно'
    } else {
      iconWrap.classList.remove('fa-bell')
      iconWrap.classList.add('fa-bell-slash')
      iconText.textContent = ' Неактивно'
    }
    localStorage.setItem('isSubscribe', !isSubscribe)
  }
  const changePushButtonState = (state) => {
    const iconWrap = pushButton.querySelector('.fa')
    const iconText = pushButton.querySelector('[data-text]')

    switch (state) {
      case 'enabled':
        pushButton.disabled = false;
        pushButton.title = 'Отключить push-уведомления';
        isPushEnabled = true;
        break;
      case 'disabled':
        pushButton.disabled = false;
        pushButton.title = 'Включить push-уведомления';
        isPushEnabled = false;
        break;
      case 'computing':
        pushButton.disabled = true;
        pushButton.title = 'Загрузка...';

        break;
      case 'incompatible':
        pushButton.disabled = true;
        pushButton.title = 'Push-уведомления несовместимы с этим браузером.';
        iconWrap.classList.remove('fa-bell')
        iconWrap.classList.add('fa-bell-slash')
        iconText.textContent = ' Неактивно'
        break;
      default:
        console.error('Unhandled push button state', state);
        break;
    }
  }
  const registerSW = () => {

    navigator.serviceWorker.register(`${window.location.origin}/serviceWorker.js?v=1.3`).then(
      () => {
        console.log('[SW] Service worker has been registered');
        // push_updateSubscription();
      },
      e => {
        console.error('[SW] Service worker registration failed', e);
        changePushButtonState('incompatible');
      }
    );
  }

  const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }

  const checkNotificationPermission = () => {
    return new Promise((resolve, reject) => {
      if (Notification.permission === 'denied') {
        return reject(new Error('Push messages are blocked.'));
      }

      if (Notification.permission === 'granted') {
        return resolve();
      }

      if (Notification.permission === 'default') {
        return Notification.requestPermission().then(result => {
          if (result !== 'granted') {
            reject(new Error('Bad permission result'));
          } else {
            resolve();
          }
        });
      }

      return reject(new Error('Unknown permission'));
    });
  }


  const push_sendSubscriptionToServer = (subscription, method) => {
    let key ;
    let token;
    if (subscription) {
      key = subscription.getKey('p256dh');
      token = subscription.getKey('auth');
    }
    const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];

    return fetch('/api/pushSubscribe', {
      method,
      body: JSON.stringify({
        endpoint: subscription ? subscription.endpoint : '',
        publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
        authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
        contentEncoding,
      }),
    }).then(() => subscription);
  }

  const push_subscribe = () => {
    changePushButtonState('computing');
    return checkNotificationPermission()
      .then(() => {

        return navigator.serviceWorker.ready
      })
      .then(serviceWorkerRegistration => {

		 return serviceWorkerRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(applicationServerKey),
		})
	  }
      )
      .then(subscription => {
        return push_sendSubscriptionToServer(subscription, 'POST');
      })
      .then(subscription => {
        return changePushButtonState('enabled')
      }) // update your UI
      .catch(e => {
        if (Notification.permission === 'denied') {
          console.warn('Notifications are denied by the user.');
          changePushButtonState('incompatible');
        } else {
          console.error('Impossible to subscribe to push notifications', e);
          changePushButtonState('disabled');
        }
      });
  }

  const push_updateSubscription = () => {
    navigator.serviceWorker.ready
      .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
      .then(subscription => {
        changePushButtonState('disabled');
        if (!subscription) {
          return;
        }
        return push_sendSubscriptionToServer(subscription, 'PUT');
      })
      .then(subscription => {
        return subscription && changePushButtonState('enabled')
      }) // Set your UI to show they have subscribed for push messages
      .catch(e => {
        console.error('Error when updating the subscription', e);
      });
  }

  const push_unsubscribe = () => {
    changePushButtonState('computing');

    navigator.serviceWorker.ready
      .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
      .then(subscription => {
        if (!subscription) {
          changePushButtonState('disabled');
          return;
        }
        return push_sendSubscriptionToServer(subscription, 'DELETE');
      })
      .then(subscription => subscription.unsubscribe())
      .then(() => changePushButtonState('disabled'))
      .catch(e => {
        console.error('Error when unsubscribing the user', e);
        changePushButtonState('disabled');
      });
  }
  const pushButtonClickHandler = () => {
    isPushEnabled ? push_unsubscribe() : push_subscribe()
    changeBtnUi()
  }
  const init = async () => {
    if (!isPossibleUseNotification()) return
    registerSW()
    pushButton.addEventListener('click', pushButtonClickHandler)
    const res = await (await fetch('/api/checkSubscribe', {method: 'GET'})).json()
    localStorage.setItem('isSubscribe', res.isSubscribeWebPush || false)
    if (res && res.isSubscribeWebPush) {
      navigator.serviceWorker.ready
        .then(serviceWorkerRegistration => serviceWorkerRegistration.pushManager.getSubscription())
        .then(subscription => {
          changePushButtonState('disabled');
          return subscription
            ? push_updateSubscription()
            : push_subscribe();
        })
        .then(subscription => {
          return subscription && changePushButtonState('enabled')
        })
    } else {
      changePushButtonState('disabled');
    }
  }

  return {
    init,
    pushButtonClickHandler,
    btnState,

  }
}
